import React from "react";

function Promotions() {
  return <div>Promotions</div>;
}

export default Promotions;
